export default __webpack_public_path__ + "media/images/images/icons/chrome-0429489714033e064379675e6ff9e6e6.png";